import { render } from "./MPatients.vue?vue&type=template&id=7b456ff3"
import script from "./MPatients.vue?vue&type=script&lang=js"
export * from "./MPatients.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__